import type { FC } from 'react';
import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SimpleContentWrapper from '../../Blocks/SimpleContentWrapper';
import SecondaryCTA from '../../Blocks/SecondaryCTA';
import ReadyToGoCore from '../../Blocks/ReadyToGoCore';
import ArtProtection from '../../Blocks/ArtProtection';
import Hero from '../../Blocks/Hero';
import Banner from '../../Blocks/Banner';
import FaqBlock from '../../Blocks/FaqBlock';

export interface Props {}

const Picker: FC<Props> = () => {
  const isMobile = useContext(MobileContext);

  return (
    <SimpleContentWrapper>
      <Hero />
      {!isMobile && <SecondaryCTA />}
      <ArtProtection />
      <FaqBlock />
      {!isMobile && (
        <>
          <ReadyToGoCore />
          <SecondaryCTA />
        </>
      )}
      <Banner />
    </SimpleContentWrapper>
  );
};
Picker.displayName = 'Picker';

export default Picker;
